import compose from 'lodash/fp/compose';
import { ff } from '@atlassian/jira-feature-flagging';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { connect } from '@atlassian/jira-react-redux';
import mapDispatchToProps from './command';
import mapStateToProps from './query';
import type { StateProps, DispatchProps, OwnProps } from './types';
import ViewOld from './view';
import ViewNew, { withScrollTracking } from './view-new';

const View = componentWithCondition(
	() => ff('jsw.roadmaps.jca11y-505-review-table-switch-to-treegrid-component_s0cfc'),
	ViewNew,
	ViewOld,
);

export default compose(
	withScrollTracking,
	connect<StateProps, DispatchProps, OwnProps, State>(mapStateToProps, mapDispatchToProps),
)(View);
